module.exports = __webpack_public_path__ + "static/media/pdf_icon_h.718b9986.svg";